// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3u-F3","legacyBtn":"MutateMid_legacyBtn__2h4GY"};